<template lang="pug">
  v-flex(xs12 sm6 md6).card-content
    v-card
      v-card-title
        v-flex(xs12 sm12 md4)
          img(:src="getURL(properties.image)")
        v-flex(xs12 sm12 md8)
          div.card-title {{ properties.title }}
          div.card-body(v-if="isRealEstate") {{ properties.description }}
          div.button(v-if="isRealEstate")
            v-btn.ml-0.primary(
              data-cy="create-contact"
              slot="activator"
              @click="validateEvocalizeAccess(properties.link)") GET STARTED
          div.button(v-else)
            v-btn.ml-0.primary.no-uppercase(
              data-cy="create-contact"
              slot="activator"
              @click="validateEvocalizeAccess(properties.linkTraffic)") Generate Traffic
            v-btn.ml-0.primary.no-uppercase(
              data-cy="create-contact"
              slot="activator"
              @click="validateEvocalizeAccess(properties.linkLeads)") Generate Leads
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const { 
  mapGetters: mapEvocalizeGetters,
  mapMutations: mapEvocalizeMutations,
} = createNamespacedHelpers('evocalize');

export default {
  props: {
    properties: Object,
  },
  computed: {
    ...mapEvocalizeGetters(['isInUsersFeed', 'isUserProcessed', 'hasUserListingProcessed']),
    isRealEstate() {
      return this.$route.params.type.replace('-', '_') === 'real_estate';
    },
  },
  methods: {
    ...mapEvocalizeMutations(['setShowIsProcessingDialog']),
    getURL(image) {
      return image ? require(`../assets/images/advertise/${image}`) : '';
    },
    validateEvocalizeAccess(redirectLink) {
      if(!this.properties.requireListingsPermission) {
        return this.redirectToEvocalize(redirectLink);
      }
      if (!this.isInUsersFeed || !this.isUserProcessed) {
        return this.setShowIsProcessingDialog(true);
      }
      if (!this.properties.requireListingsPermission || this.hasUserListingProcessed) {
        return this.redirectToEvocalize(redirectLink);
      }
      this.$router.push('/pending-access');
    },
    redirectToEvocalize(redirectLink) {
      return window.location.href = redirectLink;
    },
  }
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  margin: auto;
  width: 100%;
}
.no-uppercase {
  text-transform: none;
}
.card-content:nth-child(odd) {
  padding-right: 25px;
}
.card-content {
  display: flex;
  flex-flow: row wrap;
  text-align: center;
  .v-card {
    width: 100%;
  }
  .v-card__title {
    min-height: 352px;
    align-items: initial;
    padding: 20px;
  }
  .card-title {
    font-size: 24px;
    letter-spacing: 0.8px;
    margin: 10px 0 15px 30px;
    text-align: left;
  }
  .card-body {
    text-align: left;
    font-size: 16px;
    letter-spacing: 0.5px;
    padding: 15px 0 20px 30px;
  }
  .button {
    position: absolute;
    bottom: 32px;
    right: 28px;
  }
}
@media (max-width: 863px) {
  .card-content .button {
    bottom: 0;
    right: 0;
    position: relative;
  }
}
@media (max-width: 500px) {
  .card-content:nth-child(odd){
    padding-right: 0;
    margin-bottom: 20px;
  }
}
</style>
